module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0002_03_A18_2.3ed970a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0002_03_A18_2.jpg
// module id = mjRu
// module chunks = 0